import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { App } from '@df/core/app';
import { TimeoutService } from '@df/ng/timeout.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import take from 'lodash-es/take';
import { Subscription } from 'rxjs';
import { LocalBasket } from '../../basket/basket.decorator';
import { Section1Component } from '../../ui/display/section1/section1.component';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { CheckoutDeliveryType, CheckoutFormComponent } from '../form/checkout-form.component';
import { CheckoutStepComponent } from '../step/checkout-step.component';
@Component({
    selector: 'checkout-delivery-selection',
    templateUrl: './checkout-delivery-selection.html',
    styleUrls: ['./checkout-delivery-selection.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, FormsModule, InputWrapComponent, TranslationModule, Section1Component, InputWrapBodyDirective]
})
export class CheckoutDeliverySelectionComponent implements OnInit, OnDestroy {
    methodsLabel?: string;
    private subscriptions = new Subscription();
    protected _stepForm?: NgForm;
    @ViewChild('stepForm', { static: false })
    set stepForm(form: NgForm) {
        this.checkoutStepComponent.removeForm(this._stepForm);
        this.checkoutStepComponent.addForm(form);
        this._stepForm = form;
    }
    protected select?: (type: CheckoutDeliveryType) => void;
    constructor(
        protected checkoutFormComponent: CheckoutFormComponent,
        protected checkoutStepComponent: CheckoutStepComponent,
        protected app: App,
        protected changeDetectorRef: ChangeDetectorRef,
        protected timeoutService: TimeoutService
    ) {}
    ngOnInit() {
        this.detectChanges();
        this.select = this.timeoutService.throttle(
            (type: CheckoutDeliveryType) => {
                this.checkoutFormComponent.selectDeliveryType(type, true);
                this.detectChanges();
            },
            100,
            { trailing: true, leading: false }
        );
        this.subscriptions.add(this.app.events.on(Checkout.EVENTS.ShippingMethodsUpdate).subscribe(() => this.onMethodsUpdate()));
        this.onMethodsUpdate();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.checkoutStepComponent.removeForm(this._stepForm);
    }
    get deliveryType(): CheckoutDeliveryType | undefined {
        if (this.checkoutFormComponent.checkoutFormInitiated) {
            return this.checkoutFormComponent.deliveryTypeSelected;
        }
        return CheckoutDeliveryType.shipping;
    }
    set deliveryType(type: CheckoutDeliveryType) {}
    selectShipping(): void {
        this.select?.(CheckoutDeliveryType.shipping);
    }
    selectCollection(): void {
        this.select?.(CheckoutDeliveryType.collection);
    }
    get isCurrent(): boolean {
        return this.checkoutStepComponent.isCurrent;
    }
    protected onMethodsUpdate(): void {
        const methods = take(this.checkoutFormComponent.nonCollectionShippingMethods, 2);
        this.methodsLabel = methods.map(i => i.title).join(', ');
        this.detectChanges();
    }
    protected detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
    get disableCollection(): boolean {
        return !!(this.app.customer.basket as LocalBasket).hasGardenAssembly;
    }
}
